<div class="flex min-h-screen items-center justify-center px-6 py-12 text-center">
  <p class="text-base font-medium text-gray-700">Switching to test mode...</p>
</div>
